import { getStorage } from "./storage";

const clearMismatchedCoreIdentity = (storage, firebaseUid) => {
  const hasCachedCoreIdentity = Boolean(
    storage.getItem("user") || storage.getItem("impersonate") ||
    storage.getItem("activeClubId") || storage.getItem("preImpersonationActiveClubId")
  );

  if (
    hasCachedCoreIdentity &&
    storage.getItem("firebaseUid") !== firebaseUid
  ) {
    storage.removeItem("user");
    storage.removeItem("impersonate");
    storage.removeItem("activeClubId");
    storage.removeItem("preImpersonationActiveClubId");
    storage.removeItem("lastLoginMethod");
  }
};

export const storeFirebaseToken = (user, token) => {
  const storage = getStorage();
  const firebaseUid = user?.uid || "";

  [localStorage, sessionStorage].forEach((candidate) => clearMismatchedCoreIdentity(candidate, firebaseUid));
  storage.setItem("firebaseUid", firebaseUid);
  storage.setItem("refreshToken", user?.refreshToken || "");
  storage.setItem("token", token);
  storage.setItem("tokenLastValidity", Date.now().toString());

  return token;
};

export const persistFirebaseToken = async (
  user,
  { forceRefresh = true } = {}
) => {
  const token = await user.getIdToken(forceRefresh);
  return storeFirebaseToken(user, token);
};
